import { Text } from '@shopify/polaris';
import { deltaPercent, formatPercent } from './analyticsHelpers';

// Colored year-over-year delta. Set invert for metrics where an increase is bad (costs).
export function Delta({ current, previous, invert = false }) {
  const delta = deltaPercent(current, previous);
  if (delta === null)
    return (
      <Text tone="subdued" as="span">
        —
      </Text>
    );

  const isUp = delta > 0.001;
  const isDown = delta < -0.001;
  let tone = 'subdued';
  if (isUp) tone = invert ? 'critical' : 'success';
  if (isDown) tone = invert ? 'success' : 'critical';
  const arrow = isUp ? '▲' : isDown ? '▼' : '•';

  return (
    <Text tone={tone} as="span">
      {arrow} {formatPercent(Math.abs(delta))}
    </Text>
  );
}
